require.config({
    baseUrl: "js",
    paths: {
        aja: "lib/aja/src/aja",
        "es6-promise-polyfill": "lib/es6-promise-polyfill/promise",
        leaflet: "lib/leaflet/dist/leaflet-src",
        markercluster: "lib/markercluster/dist/leaflet.markercluster-src",
        requirejs: "lib/requirejs/require",
        t: "lib/t.js/t"
    },
    shim: {
        "display/map": {
            exports: "L"
        },
        markercluster: {
            deps: [
                "display/map"
            ]
        }
    },
    map: {
        "*": {
            http: "requester/requester",
            security: "security/apiKeySecurity"
        }
    },
    packages: [

    ]
});

define("config", function(){});

